















































import { Action, namespace, State } from "vuex-class";
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { Multipane, MultipaneResizer } from "vue-multipane";

import { Evidence } from "@/types";
import CodeSearch from "@/components/CodeSearch.vue";
import HistoryButtons from "@/components/HistoryButtons.vue";
import EvidencesList from "@/components/EvidencesList.vue";

const Evidences = namespace("evidences");

@Component({
  components: {
    EvidencesList,
    Multipane,
    MultipaneResizer,
    HistoryButtons,
    CodeSearch
  }
})
export default class EvidencesManager extends Vue {
  private search: string = "";

  private height: string = "60%";

  @Prop()
  private term!: string;

  @Prop()
  private selected!: [number, number] | null;

  @State("text")
  private document!: string;

  @Evidences.Getter("sorted")
  private evidences!: Evidence[];

  @Evidences.Getter("indexed")
  private index!: { [code: string]: Evidence };

  @Action("evidences/add")
  add!: (evidence: Evidence) => void;

  @Action("details/update")
  select!: (value: Evidence | null) => void;

  @Emit("added")
  addAndClear(evidence: Evidence) {
    if (evidence.id in this.index) {
      this.select(evidence);
    } else if (evidence.billable) {
      this.add(evidence);

      this.$nextTick(() => {
        this.select(evidence);
      });
    }

    this.search = "";
  }

  @Watch("term")
  updateSearch() {
    this.search = this.term;
  }

  @Watch("search")
  @Emit("search-updated")
  update() {
    return this.search;
  }

  mounted() {
    this.updateSearch();
  }
}
